import { MyLoadsTable } from '../views/index';
import { TIMESTAMP_FROM_STRING } from '../../utils/date/index';
import { GET_LOAD_STATUS_CLASS } from './load-status-class';
import { GET_LOAD_STATUS_TEXT } from './load-status-text';
import { LoadDTO } from '../../load/dtos/load-DTO';
import { LOAD_STATUS } from '../constants/status';
import { LOCATION_PARSER } from '../../utils/location/index';
import { GET_CARRIER_BUSINESS_NAME } from '../../carrier/utils/get-carrier-business-name';
import { IS_NOT_NULL_OR_UNDEFINED } from '../../utils';
import { FROM_UTC } from '../../utils/date/date-parser';

export const MY_LOADS_TABLE = (loadsList: Array<LoadDTO> = []): Array<MyLoadsTable> => {
	let results: Array<MyLoadsTable> = [];
	try {
		if (loadsList.length > 0) {
			loadsList.map((load) => {
				let row = {} as MyLoadsTable;
				row.created = load.created;
				row.deliveryDate = TIMESTAMP_FROM_STRING(FROM_UTC(load.deliveryDate)) || null;
				row.loadStatus = LOAD_STATUS[load.statusId];
				row.origin = LOCATION_PARSER(load.origin);
				row.destination = LOCATION_PARSER(load.destination);
				row.pickupDate = TIMESTAMP_FROM_STRING(FROM_UTC(load.pickupDate));
				row.price = Number(load.rate) || 0;
				row.trailerType = load.equipment[0].name || '';
				row.loadStatusClass = GET_LOAD_STATUS_CLASS(row.loadStatus);
				row.loadStatusText = GET_LOAD_STATUS_TEXT(row.loadStatus);
				row.loadId = load.id;

				if (load.bidCount == undefined || load.bidCount == null) {
					row.bidCount = null;
				} else {
					row.bidCount = load.bidCount;
				}
				if (load.quoteId == undefined || load.quoteId == null) {
					row.quoteId = null;
				} else {
					row.quoteId = load.quoteId;
				}
				row.url = load.url;

				row.destinationDTO = load.destination;
				row.originDTO = load.origin;
				row.referenceNumber = load.referenceNumber;
				row.productDescription = load.commodity;
				row.totalWeight = load.weight;
				row.declaredValue = load.declaredValue;
				row.teamServiceRequired = load.teamServiceRequired;
				row.revenueCode = load.revenueCode;
				row.customerName = load.customerName;
				const carrier = load.carrier;
				if (IS_NOT_NULL_OR_UNDEFINED(carrier)) {
					row.carrierId = carrier.id;
					row.carrierName = GET_CARRIER_BUSINESS_NAME(
						carrier.businessName,
						carrier.doingBusinessAs
					);
				}
				if (load.userDTO) {
					row.userDTO = load.userDTO;
					row.userName = load.userDTO.firstName + ' ' + load.userDTO.lastName;
				}
				if (IS_NOT_NULL_OR_UNDEFINED(load.offersCount)) {
					row.offersCount = load.offersCount;
				}
				if (IS_NOT_NULL_OR_UNDEFINED(load.viewsCount)) {
					row.viewsCount = load.viewsCount;
				}

				results.push(row);
			});
		}
	} catch (error) {
		console.log('MY_LOADS_TABLE error: ', error);
	}

	return results;
};
